import { useAToast } from '@Atoms';
import { compressImage } from './imageCompression.helper';

const { notify, TOAST_TYPES } = useAToast();

const TOAST_ERROR = {
  message: 'errors.generics.unknownIssue.message',
  title: 'errors.generics.unknownIssue.title',
  type: TOAST_TYPES.ERROR,
};

export async function processImageFile(
  file: File,
  options: {
    maxSizeMB?: number;
    fallbackName?: string;
  } = {}
) {
  const { maxSizeMB = 1, fallbackName = 'profile.jpg' } = options;

  try {
    const compressed = await compressImage(file, {
      maxSizeMB,
      useWebWorker: true,
    });

    const hasExtension = compressed.name.includes('.');
    const safeName = hasExtension ? compressed.name : fallbackName;

    return new File([compressed], safeName, { type: compressed.type });
  } catch (error) {
    notify(TOAST_ERROR);
    throw error;
  }
}
